import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

import TiposDeProductoConstant from 'constants/tiposDeProducto'

const TipoFormGroup = ({ iValue, fIsSubmitting, values, setValues, handleChange }) => {
  const tipoDeProductoCheckingHandler = React.useCallback(
    e => {
      handleChange(e)
      values.tipo = e.target.value

      switch (values.tipo) {
        case TiposDeProductoConstant.ACTIVO_FIJO:
          values.flagCompra = true
          values.flagVenta = false
          values.flagInventario = false
          break
        case TiposDeProductoConstant.BIEN:
          values.flagCompra = true
          values.flagVenta = true
          values.flagInventario = true
          break
        case TiposDeProductoConstant.SERVICIO:
          values.flagCompra = false
          values.flagVenta = true
          values.flagInventario = false
          break
        default:
          values.flagCompra = false
          values.flagVenta = false
          values.flagInventario = false
          break
      }

      setValues(values)
    },
    [handleChange, values, setValues]
  )

  return (
    <>
      {TiposDeProductoConstant.__array.map((val, key) => (
        <Field name='tipo' key={key}>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={iValue === val.id}
              value={val.id}
              id={`radio-tipo-${val.id}`}
              onChange={tipoDeProductoCheckingHandler}
              label={val.nombre}
            />
          )}
        </Field>
      ))}
    </>
  )
}

export default React.memo(TipoFormGroup)
